export default __webpack_public_path__ + "static/media/other3.5c83a205.jpg";